import React from "react";
import {
  Column,
  CellInfo
} from "react-table";

import { ITerminology } from "src/library/utils/string-manipulations/tokenize-string";
import TableLink from "src/library/components/Tables/TableLink";
import * as globalTableColumns from "src/core/shared/components/TableGlobalColumns";

export const approvalChangeProductsTableColumns = (terminology: ITerminology): Column[] => {
  const columns: Column[] = [
    globalTableColumns.standardText({
      Header: "Name",
      accessor: "product.description",
      filterable: false,
      sortable: false,
      Cell: (cellProps: CellInfo) => {
        if (cellProps.value) {
          return (
            <TableLink to={`/products/${cellProps.original.productId}`}>
              {cellProps.value}
            </TableLink>
          );
        }

        return null;
      }
    }),
    globalTableColumns.standardText({
      Header: terminology?.partNumber.singular.text || "Part number",
      accessor: "product.partNumber",
      sortable: false,
      filterable: false
    }),
    globalTableColumns.standardText({
      Header: "Start date",
      accessor: "startDate",
      sortable: false,
      filterable: false
    }),
    globalTableColumns.standardText({
      Header: "End date",
      accessor: "endDate",
      sortable: false,
      filterable: false
    })
  ];

  return columns;
};
